export const BOOL = [
  {
    id: 1,
    name: 'Sim'
  },
  {
    id: 0,
    name: 'Não'
  }
];